import ContinueToReadCard from './ContinueToReadCard'
import withContinueToReadCard from './withContinueToReadCard'

const ConnectedContinueToReadCard = withContinueToReadCard(ContinueToReadCard)

export { ConnectedContinueToReadCard as ContinueToReadCard }
